module.exports = __webpack_public_path__ + "static/media/refsocial.dec68d4e.svg";